import React from 'react';
import Attribute, { Attr, Type } from 'App/babel/attributes/Attribute';
import ContactAttributes from 'App/babel/attributes/Contact';
import { ListViewDefaultColumn } from 'App/components/ListView/ListViewRenderHelpers';
import LocalStorage from 'Components/Helpers/LocalStorage';
import { openColumnPicker } from 'App/components/ListView/openColumnPicker';
import type Contact from 'App/resources/Model/Contact';

const STORAGE_KEY = 'segment.contacts.columns';

const BUILT_IN_COLUMNS = ['email', 'score', 'history', 'markethistory', 'added'];
const EXTRA_COLUMNS = ['title', 'titleCategory', 'phone', 'cellPhone', 'campaigns', 'scoreUpdateDate'];
const PICKABLE = [...BUILT_IN_COLUMNS, ...EXTRA_COLUMNS];

const attributes: Record<string, Attr> = {
	...ContactAttributes,
	added: Attribute({ title: 'segment.contacts.added', field: 'segments', type: Type.Date })
};

export const EXTRA_COLUMN_FIELDS = EXTRA_COLUMNS.map(column => attributes[column].parent ?? attributes[column].field);

export const getSegmentContactColumns = () => {
	const stored = new LocalStorage().getValue<string[]>(STORAGE_KEY)?.filter(column => PICKABLE.includes(column));
	return stored?.length ? stored : BUILT_IN_COLUMNS;
};

export const pickSegmentContactColumns = (columns: string[], onPick: (columns: string[]) => void) =>
	openColumnPicker({
		attributes,
		pickable: PICKABLE,
		columns,
		tableType: 'contact',
		onPick: picked => {
			new LocalStorage().setValue(STORAGE_KEY, picked);
			onPick(picked);
		}
	});

export const columnTitle = (column: string) => attributes[column].title;

export const ExtraColumn = ({ column, contact }: { column: string; contact: Contact }) => (
	<ListViewDefaultColumn<Contact> column={column} attributes={attributes} item={contact} />
);
